import { getComputerAssetQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/computerKeys.js';
import { fetchAssetData } from '#pplx/frontend/apps/ask/spa/metadata/computerAssetData.js';
import { getComputerAssetDocumentTitle } from '#pplx/frontend/apps/ask/spa/metadata/computerAssetDocumentTitle.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
export function useComputerAssetDocumentTitle({ slug, view, enabled, }) {
    const shouldFetchTitle = enabled && !!slug;
    const queryView = shouldFetchTitle ? view : undefined;
    const { data } = useQuery({
        queryKey: getComputerAssetQueryKey(shouldFetchTitle ? slug : undefined, queryView),
        queryFn: fetchAssetData,
        enabled: shouldFetchTitle,
        retry: false,
        staleTime: 30 * 60 * 1000,
    });
    return getComputerAssetDocumentTitle(data?.asset_data);
}
//# sourceMappingURL=useComputerAssetDocumentTitle.js.map